import { Button } from 'antd'
import styled from 'styled-components'

export const StyledInputFileButton = styled(Button)``

export const StyledInputFile = styled.div``
